import React from "react";
import { useMutation } from "react-query";
import "./ConcurrentTable.scss";
import firefox_icon from "../../assets/images/firefox-icon.svg";
import chrome_icon from "../../assets/images/chrome-icon.svg";
import postman_icon from "../../assets/images/postman_icon.svg";
import windows_icon from "../../assets/images/windows-icon.svg";
import { I2cButton, I2cIcon } from "@webcomponents/i2cwebcomponents/dist/react";
import ConcurrentSessionService from "../../Services/ConcurrentSession";
import { getFormatedDate } from "../../Utils/stringUtls";

/**
 * Component representing a single session in the Concurrent Table.
 * @param {Object} session - The session data.
 * @param {number} sessionNumber - The session number.
 * @param {Function} onSessionDelete - Function to handle session deletion.
 * @returns JSX.Element
 */
const SingleSession = ({ session, sessionNumber, onSessionDelete }) => {
  // Determine the browser agent from the user agent string
  const agent = session.user_agent.includes("chrome")
    ? "Chrome"
    : session.user_agent.includes("PostmanRuntime")
      ? "Postman"
      : "Firefox";

  // Format the date and time from the last activity
  const formattedDateTime = getFormatedDate(session.last_activity);

  // Define the delete session mutation hook
  const deleteSessionMutation = useMutation((session) =>
    ConcurrentSessionService.killSession(session),
  );

  // Function to handle session deletion
  const handleSessionDelete = async (session) => {
    try {
      // Call the delete session mutation
      await deleteSessionMutation.mutateAsync(session);
      // If deletion is successful, refetch the data
      onSessionDelete && onSessionDelete();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <tr key={sessionNumber}>
      <td>Session {sessionNumber}</td>
      <td data-th="IP Address">{session.ip_address}</td>
      <td data-th="User Agent">
        <div className="contentwith__icon">
          <I2cIcon
            src={
              agent === "Firefox"
                ? firefox_icon
                : agent === "Postman"
                  ? postman_icon
                  : chrome_icon
            }
            label="icon"
            library="default"
            color=""
          ></I2cIcon>
          <span>{agent}</span>
        </div>
      </td>
      <td data-th="Device Type">
        <div className="contentwith__icon">
          <i2c-icon
            class="w-icon-device-type"
            name="windows-icon"
            slot="suffix"
          ></i2c-icon>
          <span>Windows</span>
        </div>
      </td>
      <td data-th="Login Date">{formattedDateTime.date}</td>
      <td data-th="Login Time">{formattedDateTime.time}</td>
      <td>
        <div className="btngrid--desk">
          {/* Button to kill session on desktop */}
          <span
            className="kill-session-button"
            onClick={() => handleSessionDelete(session)}
          >
            Kill Session
          </span>
        </div>
        {/* Button to kill session on mobile */}
        <I2cButton
          className="kill-session-mobile"
          variant="gray"
          onClick={() => handleSessionDelete(session)}
          loading={deleteSessionMutation.isLoading}
        >
          Kill Session
        </I2cButton>
      </td>
    </tr>
  );
};

export default SingleSession;
